import React from 'react'

// ui-kit
import { Chip } from '@navent-jobs/ui-kit/components/chip'

// components
import EstadoPostulacion from '../EstadoPostulacion/index'

// mixins
import { EstadoWrapper, ChipsContainer } from './mixins'

// constants
import features from '../../../../../../../constants/features-per-country'
import { SITE_ID } from '../../../../../../../constants'

const featureAutopostulacion = features[SITE_ID ?? 'BMAR'].autopostulacion.enabled

interface ChipListProps {
  estado: string
  totalComments: number
  origen: string
  fitContent?: boolean
}

const ChipList = ({ estado, totalComments, origen, fitContent = false }: ChipListProps) => {
  const showAutopostulacion = featureAutopostulacion && origen === 'AUTOPOSTULACION'

  return (
    <ChipsContainer>
      <EstadoWrapper estado={estado} fitContent={fitContent}>
        <EstadoPostulacion estado={estado} totalComments={totalComments} />
      </EstadoWrapper>

      {showAutopostulacion && (
        <Chip
          text="Postulado por Mia"
          iconName="icon-light-ia-stars"
          chipOptions={{ color: 'black', skin: 'fill', variant: 'lighten', size: 'small' }}
        />
      )}
    </ChipsContainer>
  )
}

export default ChipList
